export default {
  accountMaps: [],
  accountMap: undefined,
};
